<template>
  <!-- prettier-ignore -->
  <basic-query-select
    v-bind="$attrs"
    v-model="model"
    name="location"
    :required="$props.required"
    :disabled="$props.disabled"
    :is-loading="isSearchInProgress"
    :label="$props.label"
    :supporting-text="$t('location.placeholder')"
    :results="locationResults"
    :v="v"
    @search="doTheSearch"
  />
</template>

<script setup>
import { reactive, ref } from 'vue'

import { ReactivityUtil } from '@/utils/Reactivity'

import masterDataAPI from '@/api/open/masterData'

import BasicQuerySelect from '@/components/Basic/QuerySelect'

// INIT
const model = defineModel({ type: [Object] })
defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },

  hasTrailing: {
    type: Boolean,
    default: false,
  },

  label: {
    type: String,
    required: true,
  },

  required: {
    type: Boolean,
    default: false,
  },

  size: {
    validator(value) {
      return ['sm', 'md'].includes(value)
    },
    default: 'sm',
  },

  supportingText: {
    type: String,
    default: undefined,
  },

  v: {
    type: Object,
    default: () => {},
  },

  value: {
    type: Object,
    default: () => {},
  },
})

// DATA
const locationResults = reactive([])
const isSearchInProgress = ref(false)

// METHODS
async function searchLocation(searchQuery) {
  const payload = {
    query: searchQuery.toString(),
  }
  isSearchInProgress.value = true
  const locations = await masterDataAPI.getDomesticLocations(payload)
  isSearchInProgress.value = false
  return locations.map(location => {
    const { zipCode, locationName } = location
    return {
      value: location,
      label: `${zipCode} ${locationName}`,
    }
  })
}

async function doTheSearch(query) {
  if (query.length > 1) {
    const locations = await searchLocation(query)
    ReactivityUtil.reAssign(locationResults, locations)
  }
}
</script>
